// 高清韩国漫画 - 漫画内容数据（示例数据，用于展示网站完整效果）

export interface Comic {
  id: number;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  chapters: number;
  status: string; // 连载 / 完结
  rating: number;
  likes: number;
  badge?: string; // 新作 / 热度 / 完结 / 爆款
  summary: string;
  cover: string;
}

export interface Genre {
  key: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
  tagline: string;
  color: string;
}

export const genres: Genre[] = [
  {
    key: "romance",
    name: "恋爱",
    desc: "心动日常与甜蜜纠葛",
    count: "1,200+",
    icon: "ri-heart-3-fill",
    tagline: "怦然心动的每一刻",
    color: "primary",
  },
  {
    key: "fantasy",
    name: "奇幻",
    desc: "魔法世界与异界冒险",
    count: "980+",
    icon: "ri-sparkling-2-fill",
    tagline: "通往幻想世界的入口",
    color: "accent",
  },
  {
    key: "school",
    name: "校园",
    desc: "青春校园与同桌故事",
    count: "860+",
    icon: "ri-graduation-cap-fill",
    tagline: "属于青春的回忆",
    color: "secondary",
  },
  {
    key: "mystery",
    name: "悬疑",
    desc: "烧脑推理与都市谜案",
    count: "640+",
    icon: "ri-search-eye-fill",
    tagline: "真相藏在细节之中",
    color: "secondary",
  },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "心动信号",
    author: "林夏",
    genre: "恋爱",
    tags: ["校园", "甜宠", "日常"],
    chapters: 138,
    status: "连载",
    rating: 9.6,
    likes: 86200,
    badge: "爆款",
    summary: "转学到新班级的少女，却意外发现自己暗恋多年的男生就在隔壁。青涩的悸动与迟到的告白，让这个夏天变得格外滚烫。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20art%2C%20young%20couple%20blushing%20on%20school%20rooftop%20at%20golden%20hour%2C%20cherry%20blossoms%20in%20the%20air%2C%20warm%20coral%20and%20pink%20tones%2C%20clean%20flat%20illustration%2C%20soft%20dreamy%20glow%2C%20no%20text&width=600&height=800&seq=comic-xd-01&orientation=portrait",
  },
  {
    id: 2,
    title: "月下契约",
    author: "苏禾",
    genre: "奇幻",
    tags: ["魔法", "契约", "冒险"],
    chapters: 96,
    status: "连载",
    rating: 9.4,
    likes: 71500,
    badge: "热度",
    summary: "一场月下的约定，让平凡的少女与传说中的契约精灵相遇。踏入被遗忘的魔法世界，她必须守护那个赌上性命的诺言。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20comic%20cover%2C%20boy%20and%20mysterious%20girl%20making%20a%20pact%20under%20glowing%20full%20moon%2C%20moonlit%20forest%20with%20teal%20green%20and%20warm%20gold%20magic%20particles%2C%20clean%20fantasy%20illustration%2C%20mysterious%20atmosphere%2C%20no%20text&width=600&height=800&seq=comic-yx-02&orientation=portrait",
  },
  {
    id: 3,
    title: "天台告白",
    author: "陈屿",
    genre: "恋爱",
    tags: ["校园", "初恋", "治愈"],
    chapters: 72,
    status: "连载",
    rating: 9.2,
    likes: 64800,
    summary: "把告白写满整个天台，是十七岁最勇敢也最笨拙的浪漫。当那句喜欢终于说出口，青春也开始了另一种形状。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%2C%20shy%20boy%20confessing%20love%20on%20school%20rooftop%2C%20warm%20sunset%20orange%20and%20pink%20sky%2C%20gentle%20wind%2C%20tender%20mood%2C%20clean%20flat%20illustration%2C%20no%20text&width=600&height=800&seq=comic-tt-03&orientation=portrait",
  },
  {
    id: 4,
    title: "迷城疑云",
    author: "顾白",
    genre: "悬疑",
    tags: ["推理", "都市", "犯罪"],
    chapters: 64,
    status: "连载",
    rating: 9.5,
    likes: 78200,
    badge: "热度",
    summary: "接连发生的神秘失踪案，指向一座废弃多年的旧城。侦探少女循着蛛丝马迹深入迷雾，却发现谜底就藏在身边。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20thriller%20comic%20cover%2C%20detective%20silhouette%20in%20foggy%20city%20alley%20at%20night%2C%20dramatic%20teal%20and%20amber%20lighting%2C%20noir%20mood%2C%20clean%20illustration%2C%20suspenseful%2C%20no%20text&width=600&height=800&seq=comic-mc-04&orientation=portrait",
  },
  {
    id: 5,
    title: "契约婚姻",
    author: "林夏",
    genre: "恋爱",
    tags: ["总裁", "契约", "先婚后爱"],
    chapters: 110,
    status: "连载",
    rating: 9.3,
    likes: 69100,
    summary: "一纸各取所需的婚姻契约，把两个毫无交集的人绑在了一起。当合约即将到期，那些假戏真做的瞬间却越来越真实。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%2C%20elegant%20man%20and%20woman%20in%20formal%20attire%20near%20a%20glass%20wall%20with%20warm%20golden%20interior%20lighting%2C%20romantic%20tension%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-qy-05&orientation=portrait",
  },
  {
    id: 6,
    title: "星轨恋歌",
    author: "苏禾",
    genre: "奇幻",
    tags: ["星际", "宿命", "治愈"],
    chapters: 88,
    status: "连载",
    rating: 9.1,
    likes: 58700,
    summary: "在遥远的星轨上，两个来自不同星球的灵魂因一场流星雨而相遇。跨越光年的爱恋，能否挣脱宿命写下的轨迹。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20romance%20comic%20cover%2C%20couple%20standing%20under%20starry%20night%20sky%20with%20glowing%20constellations%2C%20deep%20teal%20and%20gold%20palette%2C%20magical%20sparkles%2C%20romantic%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-xg-06&orientation=portrait",
  },
  {
    id: 7,
    title: "夜色未眠",
    author: "顾白",
    genre: "悬疑",
    tags: ["惊悚", "都市", "谜案"],
    chapters: 52,
    status: "连载",
    rating: 9.0,
    likes: 53400,
    summary: "城市沉睡之后，总有一些不该醒来的真相在暗处涌动。失眠的电台主持人，在深夜节目里收到了一封封危险的来信。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20comic%20cover%2C%20night%20city%20skyline%20silhouette%20with%20a%20single%20glowing%20window%2C%20moody%20teal%20and%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-ys-07&orientation=portrait",
  },
  {
    id: 8,
    title: "转学生来袭",
    author: "陈屿",
    genre: "校园",
    tags: ["喜剧", "青春", "日常"],
    chapters: 145,
    status: "连载",
    rating: 9.2,
    likes: 72300,
    summary: "新学期空降的元气转学生，用她的热情搅动了整个安静的班级。啼笑皆非的日常背后，藏着关于友谊与成长的青春必修课。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20comic%20cover%2C%20cheerful%20transfer%20student%20with%20backpack%20waving%20in%20a%20colorful%20classroom%2C%20bright%20warm%20cheerful%20colors%2C%20clean%20flat%20illustration%2C%20no%20text&width=600&height=800&seq=comic-zx-08&orientation=portrait",
  },
  {
    id: 9,
    title: "魔法书店",
    author: "苏禾",
    genre: "奇幻",
    tags: ["魔法", "治愈", "日常"],
    chapters: 79,
    status: "连载",
    rating: 9.4,
    likes: 66900,
    badge: "新作",
    summary: "深巷里藏着一家只在午夜营业的魔法书店，每一本书都住着一个等待被阅读的故事。推开店门的少女，成了新任的书店守夜人。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20comic%20cover%2C%20cozy%20magical%20bookstore%20with%20glowing%20bookshelves%20and%20floating%20books%2C%20warm%20amber%20and%20teal%20lighting%2C%20whimsical%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-mf-09&orientation=portrait",
  },
  {
    id: 10,
    title: "迟来的告白",
    author: "林夏",
    genre: "恋爱",
    tags: ["初恋", "虐心", "HE"],
    chapters: 156,
    status: "完结",
    rating: 9.7,
    likes: 95800,
    badge: "完结",
    summary: "那封没有寄出的信，在抽屉里躺了十年。当两人在熟悉的街角重逢，迟来的告白终于有了说出口的勇气。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%2C%20love%20letter%20and%20dried%20flowers%20on%20a%20wooden%20desk%2C%20soft%20warm%20pastel%20nostalgic%20tones%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-cl-10&orientation=portrait",
  },
  {
    id: 11,
    title: "幻境迷宫",
    author: "苏禾",
    genre: "奇幻",
    tags: ["冒险", "穿越", "热血"],
    chapters: 142,
    status: "完结",
    rating: 9.3,
    likes: 81700,
    badge: "完结",
    summary: "被困在永无止境的幻境迷宫中，少年们必须依靠勇气与智慧寻找出口。每一次选择，都在改写彼此的命运。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20comic%20cover%2C%20hero%20standing%20before%20a%20surreal%20geometric%20maze%20of%20light%2C%20teal%20green%20and%20gold%20energy%2C%20epic%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-hj-11&orientation=portrait",
  },
  {
    id: 12,
    title: "樱花入学式",
    author: "陈屿",
    genre: "校园",
    tags: ["青春", "友情", "治愈"],
    chapters: 168,
    status: "完结",
    rating: 9.5,
    likes: 90400,
    badge: "完结",
    summary: "樱花盛开的入学式上，四个性格迥异的少年少女成为了同班同学。三年时光，一起哭过笑过的青春永远闪耀。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20comic%20cover%2C%20students%20walking%20through%20a%20cherry%20blossom%20lane%20on%20their%20first%20day%2C%20pink%20and%20warm%20cream%20palette%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-yh-12&orientation=portrait",
  },
  {
    id: 13,
    title: "无声证词",
    author: "顾白",
    genre: "悬疑",
    tags: ["推理", "法庭", "反转"],
    chapters: 128,
    status: "完结",
    rating: 9.6,
    likes: 88300,
    badge: "完结",
    summary: "无法开口的目击者，用一枚枚无声的证词指认真相。法医少女在一桩桩扑朔迷离的案件中，为沉默者发声。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20comic%20cover%2C%20magnifying%20glass%20and%20evidence%20on%20a%20table%20in%20a%20dark%20room%2C%20amber%20lamp%20light%2C%20dramatic%20shadows%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-ws-13&orientation=portrait",
  },
  {
    id: 14,
    title: "红月之下",
    author: "苏禾",
    genre: "奇幻",
    tags: ["吸血鬼", "宿命", "暗黑"],
    chapters: 67,
    status: "连载",
    rating: 9.1,
    likes: 59600,
    badge: "新作",
    summary: "当红月升起，沉睡的传说便会苏醒。误入古堡的人类少女，与禁忌的守夜人之间，展开了一场跨越种族的宿命之恋。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20comic%20cover%2C%20red%20moon%20over%20a%20gothic%20castle%2C%20dark%20red%20and%20warm%20orange%20tones%2C%20mysterious%20romantic%20atmosphere%2C%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-hy-14&orientation=portrait",
  },
  {
    id: 15,
    title: "心跳同频",
    author: "林夏",
    genre: "恋爱",
    tags: ["医生", "双向奔赴", "治愈"],
    chapters: 92,
    status: "连载",
    rating: 9.2,
    likes: 61200,
    summary: "一场手术台的意外相遇，让理性冷静的外科医生与温柔坚定的急诊护士走到了一起。心跳同频的瞬间，爱情悄悄生根发芽。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%2C%20two%20hands%20almost%20touching%20with%20glowing%20heart%20energy%20between%20them%2C%20warm%20coral%20and%20gold%2C%20soft%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-xt-15&orientation=portrait",
  },
  {
    id: 16,
    title: "雪夜谜案",
    author: "顾白",
    genre: "悬疑",
    tags: ["本格推理", "冬日", "迷局"],
    chapters: 58,
    status: "完结",
    rating: 9.4,
    likes: 73100,
    badge: "完结",
    summary: "大雪封路的山间旅馆，一场精心策划的连环谜案悄然上演。被困的旅客们各怀秘密，谁是凶手，谁又在说谎。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20comic%20cover%2C%20snowy%20night%20street%20with%20detective%20footprints%2C%20cool%20teal%20and%20warm%20amber%20lamplight%2C%20suspenseful%20clean%20illustration%2C%20no%20text&width=600&height=800&seq=comic-xa-16&orientation=portrait",
  },
];